import LegacyApp from "./legacy/App";

function OldApp() {
  return <LegacyApp />;
}

export default OldApp;
